/**
 * Convert a file to base64
 * @param file  File to convert
 * @param compact If true, the base64 string will be compacted, without content type and base64 prefix
 */
export const fileToBase64 = (file: File, compact: boolean): Promise<string> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      if (compact) {
        resolve(reader.result?.toString().split(',')[1] || '');
        return;
      }
      resolve(reader.result as string);
    };
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
};

/**
 * Detects browser File instances stored in form state without relying on
 * deprecated properties such as `lastModifiedDate`.
 *
 * @param value - Candidate value coming from form state
 * @returns True when the value behaves like a browser File
 */
export const isBrowserFile = (value: unknown): value is File => {
  if (typeof File !== 'undefined' && value instanceof File) {
    return true;
  }

  if (typeof Blob === 'undefined' || !(value instanceof Blob)) {
    return false;
  }

  const candidate = value as Partial<File>;

  return (
    typeof candidate.name === 'string' &&
    typeof candidate.size === 'number' &&
    typeof candidate.type === 'string' &&
    typeof candidate.lastModified === 'number'
  );
};
